import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { LogoIcon } from '../components/Logo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback({ setUser }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          toast.error('Authentication failed - no session ID');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];
        
        // Get signup data from sessionStorage if this was a signup flow
        const signupData = sessionStorage.getItem('google_signup_data');
        let isSignup = false;
        let companyName = null;
        let companySize = null;
        
        if (signupData) {
          const parsed = JSON.parse(signupData);
          isSignup = parsed.isSignup;
          companyName = parsed.companyName;
          companySize = parsed.companySize;
          sessionStorage.removeItem('google_signup_data');
        }

        // Exchange session_id for user data
        const response = await axios.post(`${API}/auth/google-session`, {
          session_id: sessionId,
          is_signup: isSignup,
          company_name: companyName,
          company_size: companySize
        }, {
          withCredentials: true
        });

        const { token, user, email_verified, message } = response.data;

        // Store auth data
        localStorage.setItem('hrms_token', token);
        localStorage.setItem('hrms_user', JSON.stringify(user));
        
        if (setUser) {
          setUser(user);
        }

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        if (!email_verified) {
          // Redirect to verify email page
          toast.info('Please verify your email to continue');
          navigate('/verify-email', { state: { user } });
        } else {
          // Redirect to dashboard
          toast.success('Logged in successfully!');
          navigate('/dashboard', { state: { user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(error.response?.data?.detail || 'Authentication failed');
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="text-center">
        <div className="flex items-center justify-center space-x-3 mb-6">
          <LogoIcon className="h-12 w-12" />
          <div className="flex items-baseline space-x-1">
            <span className="text-3xl font-bold text-white">MyHR</span>
            <span className="text-3xl font-bold text-emerald-400">Orbit</span>
          </div>
        </div>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-400 mx-auto mb-4"></div>
        <p className="text-slate-400">Completing sign in...</p>
      </div>
    </div>
  );
}
